<template>
  <div id="marketDashboardArea">
    <div class="report-loader text-center" v-if="loading">
      <img src="/images/loading.gif" />
    </div>
    <div v-else>
      <div
        :style="slug === 'dashboard' || preview === true ? '' : 'display:none;'"
      >
        <DashboardPageComponent
          :companyName="companyName"
          :companyLogo="companyLogo"
          :dashboardPage="dashboardPage"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        :style="
          slug === 'terminology-methodology' || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <TerminologyMethodologyComponent
          :isPDF="false"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        :style="
          slug === 'indicator-definitions' || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <DefinitionOfIndicatorsComponent
          :companyLogo="companyLogo"
          :indicatorDefinitions="indicatorDefinitions"
          :reportTypeId="reportTypeId"
        />
      </div>
      <div
        :style="
          slug === 'management-objectives' || preview === true
            ? ''
            : 'display:none;'
        "
      >
        <ManagementObjectivesComponent
          :companyLogo="companyLogo"
          :reportTypeId="reportTypeId"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import DashboardPageComponent from '~/components/report/modules/live-report/dashboard/DashboardPageComponent.vue';
  import DefinitionOfIndicatorsComponent from '~/components/report/modules/live-report/shared/DefinitionOfIndicatorsComponent.vue';
  import ManagementObjectivesComponent from '~/components/report/modules/live-report/shared/ManagementObjectivesComponent.vue';
  import TerminologyMethodologyComponent from '~/components/report/modules/live-report/dashboard/TerminologyMethodologyComponent.vue';

  export default {
    name: 'DashboardComponent',
    props: {
      slug: {
        type: String,
        default: '',
      },
      apiID: {
        type: [String, Number],
        default: '',
      },
      reportID: {
        type: [String, Number],
        default: '',
      },
      index: {
        type: [String, Number],
        default: 0,
      },
      preview: {
        type: Boolean,
        default: false,
      },
      consulting_slug: {
        type: String,
        default: '',
      },
      apiResponse: {
        type: Object,
        default() {
          return {};
        },
      },
      reportTypeId: {
        type: [String, Number],
        default: 0,
      },
    },
    components: {
      DashboardPageComponent,
      DefinitionOfIndicatorsComponent,
      ManagementObjectivesComponent,
      TerminologyMethodologyComponent,
    },
    data() {
      return {
        loading: true,
        companyName: '',
        companyLogo: '',
        indicatorDefinitions: {
          evenRows: [],
          oddRows: [],
          definitions: [],
        },
        reportDate: '',
        dashboardPage: {},
      };
    },
    mounted() {
      this.setData();
    },
    methods: {
      downloadPDF() {
        axios
          .get(
            '/consulting/download-dashboard-pdf/' +
              this.apiID +
              '/' +
              this.reportID
          )
          .then((success) => {
            $('#loadingFileModal').modal('hide');

            //create a tag to download new PDF
            var a = document.createElement('a');
            a.href = '/' + success.data.pdf;
            a.download = success.data.file_name;
            document.body.append(a);
            a.click();
            a.remove();
          })
          .catch(function (error) {
            $('#loadingFileModal').modal('hide');
          });
      },
      setData() {
        //parses apiResponse into objects that can be passed into each child component

        this.reportDate = this.apiResponse.ReportDate ?? '';
        this.companyName = this.apiResponse.CompanyName ?? '';
        this.companyLogo = this.apiResponse.CompanyLogo ?? '';
        this.dashboardPage = this.apiResponse.DashboardPage ?? {};

        //definition page
        this.indicatorDefinitions = {
          evenRows: [],
          oddRows: [],
          definitions:
            this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows,
        };

        //loop and set even and odd rows of indicator definitions page
        for (
          let i = 0;
          i <
          this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows
            .length;
          ++i
        ) {
          if (i % 2 === 0) {
            this.indicatorDefinitions.evenRows.push(
              this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[i]
            );
          } else {
            this.indicatorDefinitions.oddRows.push(
              this.apiResponse.DefinitionsPage.IndicatorDefinitionsTable.Rows[i]
            );
          }
        }

        this.buildPageDropDownMenu();
      },
      buildPageDropDownMenu: function () {
        var pages = document.getElementById('report-page');
        pages.innerHTML = '';

        //map definitions
        var dashboard = document.createElement('option');
        dashboard.text = 'Dashboard';
        dashboard.value = 'dashboard';
        dashboard.selected = this.slug === 'dashboard';
        pages.add(dashboard);

        //terminology
        var terminology = document.createElement('option');
        terminology.text = 'Terminology and Methodology';
        terminology.value = 'terminology-methodology';
        terminology.selected = this.slug === 'terminology-methodology';
        pages.add(terminology);

        //map definitions
        var definitions = document.createElement('option');
        definitions.text = 'Indicator Definitions';
        definitions.value = 'indicator-definitions';
        definitions.selected = this.slug === 'indicator-definitions';
        pages.add(definitions);

        //management objective
        var management = document.createElement('option');
        management.text = 'Management Objectives';
        management.value = 'management-objectives';
        management.selected = this.slug === 'management-objectives';
        pages.add(management);

        if (!this.preview) {
          //handle paginations
          document.getElementById('paginationPagesLabel').innerHTML =
            pages.selectedIndex + 1 + '/' + pages.length;
        }

        this.loading = false;
      },
      getBase64Image: function (img) {
        if (img) {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          var dataURL = canvas.toDataURL('image/png');
          // return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
          return dataURL;
        }
      },
    },
  };
</script>
